import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type UpdateConstructionInput, updateConstruction } from "@/adapters/api";

export function useUpdateObra(id: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: UpdateConstructionInput) => {
			if (!id) throw new Error("missing construction id");
			return updateConstruction(id, input);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["obras"] });
		},
	});
}
